import { useContext, useMemo } from 'react'
import { SociogramActionsContext, SociogramStateContext } from '@BUP/contexts/sociogram-contexts'

export const useSociogramState = () => {
  const context = useContext(SociogramStateContext)
  if (!context) {
    throw new Error('useSociogramState must be used within a SociogramContextProvider')
  }
  return context
}

export const useSociogramActions = () => {
  const context = useContext(SociogramActionsContext)
  if (!context) {
    throw new Error('useSociogramActions must be used within a SociogramContextProvider')
  }
  return context
}

export const useSociogramContext = () => {
  const state = useSociogramState()
  const actions = useSociogramActions()

  return useMemo(() => ({
    ...state,
    ...actions
  }), [state, actions])
}
